import { Head, Link, usePage } from "@inertiajs/react"

import { dashboardPath, signInPath } from "@/routes"

export default function Welcome() {
  const page = usePage()
  const { auth } = page.props

  return (
    <>
      <Head title="Welcome" />

      <div className="flex min-h-screen flex-col items-center justify-center bg-white dark:bg-[#0a0a0a]">
        <main className="flex items-center justify-center p-6">
          <img
            src="/alfred.png"
            alt="Alfred"
            className="h-auto max-h-[500px] max-w-full rounded-lg"
          />
        </main>
        <header className="">
          <nav>
            {auth.user ? (
              <Link
                href={dashboardPath()}
                className="inline-block rounded-md bg-[#1b1b18] px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-black dark:bg-[#eeeeec] dark:text-[#1C1C1A] dark:hover:bg-white"
              >
                Dashboard
              </Link>
            ) : (
              <Link
                href={signInPath()}
                className="inline-block rounded-md bg-[#1b1b18] px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-black dark:bg-[#eeeeec] dark:text-[#1C1C1A] dark:hover:bg-white"
              >
                Log in
              </Link>
            )}
          </nav>
        </header>
      </div>
    </>
  )
}
